// extracted by mini-css-extract-plugin
module.exports = {"EmptyResultsContainer":"EmptyResultsContainer__3GtdE"};